import { useState } from 'react';
import PropTypes from 'prop-types';
import { RadioInputSection } from '@phso-dt/common';
import Button from '../Button/Button';
import './QuestionCard.scss';

const QuestionCard = ({
  question,
  options = [],
  required = true,
  selectedValue = '',
  onChange,
  onPrevious,
  onNext,
  showPrevious = true,
  nextDisabled = true,
  name = 'question-option',
  children,
}) => {
  const [showError, setShowError] = useState(false);

  const radioButtons = options.map(({ value, label }) => ({ value, text: label }));

  const handleChange = (value) => {
    setShowError(false);
    if (onChange) {
      onChange(value);
    }
  };

  const handleNext = () => {
    if (nextDisabled) {
      setShowError(true);
      return;
    }
    setShowError(false);
    if (onNext) onNext();
  };

  return (
    <div className="question-card">
      <div className="question-card__content">
        <RadioInputSection
          key={name}
          label={question}
          radioButtons={radioButtons}
          isRequired={required}
          name={name}
          onChange={handleChange}
          selectedValue={selectedValue}
          errorMessage={showError ? 'Please select an option to continue' : undefined}
        />

        {children}
      </div>

      <div className={`question-card__actions ${!showPrevious ? 'question-card__actions--single' : ''}`}>
        {showPrevious && (
          <Button
            variant="previous"
            onClick={onPrevious}
            className="question-card__btn"
          >
            Previous question
          </Button>
        )}
        <Button
          variant="continuation"
          onClick={handleNext}
          disabled={nextDisabled}
          className="question-card__btn"
        >
          Next question
        </Button>
      </div>
    </div>
  );
};

QuestionCard.propTypes = {
  question: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  required: PropTypes.bool,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  showPrevious: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  name: PropTypes.string,
  children: PropTypes.node,
};

export default QuestionCard;
